const dateFormatter = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric" });

function parseDate(value: string) {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day));
}

export function formatDateRange(startsOn: string | null, endsOn: string | null, timeZone?: string) {
  if (!startsOn && !endsOn) return timeZone ? `Not set · ${timeZone}` : "Not set";
  const start = startsOn ? parseDate(startsOn) : null;
  const end = endsOn ? parseDate(endsOn) : null;
  let value: string;
  if (start && end && start.getUTCFullYear() === end.getUTCFullYear() && start.getUTCMonth() === end.getUTCMonth()) {
    const monthYear = new Intl.DateTimeFormat("en-GB", { month: "short", year: "numeric", timeZone: "UTC" }).format(end);
    value = `${start.getUTCDate()}–${end.getUTCDate()} ${monthYear}`;
  } else if (start && end) value = `${dateFormatter.format(start)}–${dateFormatter.format(end)}`;
  else value = dateFormatter.format(start ?? end!);
  return timeZone ? `${value} · ${timeZone}` : value;
}

export function formatDateTime(value: string, timeZone: string) {
  return `${new Intl.DateTimeFormat("en-GB", { dateStyle: "medium", timeStyle: "short", timeZone }).format(new Date(value))} · ${timeZone}`;
}
